import { SEPTIC_GPM_TABLE } from "../../../data/gpm";
import { FormulaResult, PumpSizingFormData } from "../../../types/types";
import { parseNumericValue } from "../../helpers/helpers";

export function calculateSepticGpm(formData: PumpSizingFormData): FormulaResult {
	const { septic } = formData.gpmData;
	const {
		systemType,
		distalPressure,
		orificesPerLateral,
		orificeFraction,
		totalLaterals,
		pipeDiameter,
	} = septic;

	if (systemType === "lowPressure") {
		const orificeSize = calculatedOrificeSize(orificeFraction);
		return (
			11.79 *
			orificeSize ** 2 *
			Math.sqrt(parseNumericValue(distalPressure)) *
			parseNumericValue(orificesPerLateral) *
			parseNumericValue(totalLaterals)
		);
	}

	if (systemType === "conventional") {
		if (!pipeDiameter) {
			return null;
		}
		return SEPTIC_GPM_TABLE[pipeDiameter] ?? 0;
	}

	return null;
}

function calculatedOrificeSize(orificeFraction: string): number {
	const [numerator, denominator] = orificeFraction.split("/");
	return (
		parseNumericValue(numerator) / parseNumericValue(denominator)
	);
}
